import React from 'react'
import './skills.css'
import Frontend from './Frontend'
import MicrosoftOffice from './MicrosoftOffice'

const Skills = () => {
  return (
    <section className="skills section" id="skills">
        <h2 className="section__title" data-aos="fade-right">Skills</h2>
        <span className="section__subtitle" data-aos="fade-right" data-aos-delay="200">My technical level</span>

        <div className="skills__container container grid">
            <Frontend />
            <MicrosoftOffice />
        </div>
    </section>
  )
}

export default Skills